<div class="row justify-content-center mg-top-40" *ngIf="radicado">
  <div class="col-xs-12 col-md-10">
    <div class="card card--one bg-white mg-btm-30 row justify-content-center">
      <div class="col-xs-12 col-md-6 col-lg-5 mg-top-40">
      </div>
      <div class="col-xs-12 text-center mg-btm-90 file-name">
          <div class="icon-middle-line section mg-btm-40">
            <div class="shadow-item text-center round-icon round-icon--bg-white">
              <span class="step-item_icon">
                <em aria-hidden="true" class="material-icons icon-process-success">check</em>
              </span>
            </div>
          </div>
          <div class="box-shadow">
            <h2 class="color-blue-light u-bold font-20 text-center-vertical">
              El archivo ha sido recibido exitosamente y se encuentra en proceso de validación. <br>La
              respuesta será enviada en el transcurso de las próximas 24 horas.<br><br>Número de radicado: {{radicado}}
            </h2>
        </div>
      </div>

      <div class="col-xs-12 col-md-12">
        <div class="pad-sm-none d-flex justify-content-center text-center mg-btm-30">
          <div class="col-xs-12 col-md-4">
            <a [routerLink]="'/'+home" class="u-btn--light u-btn u-btn--blue u-btn--small u-btn--icon mg-btm-30">
              <!--<em class="material-icons">navigate_next</em>-->
                Aceptar</a>
          </div>
        </div>
      </div><!-- /button options -->
    </div>
  </div>
</div>


<!--CAJA DE MENSAJE DE ERROR-->
<!--CAJA DE MENSAJE DE ERROR-->
<div class="col-xs-12" *ngIf="code">
    <div class="col-xs-12 text-center mg-btm-90 file-name">
      <div class="icon-middle-line section mg-btm-40">

          <span class="icon-living-place icon-living-place-error shadow-item text-center">
            <em aria-hidden="true" class="material-icons color-red icon-process-error ">cancel</em>
          </span>

      </div>
      <div class="white-box row container pdd-btm-40">
        <span class="color-blue-dark pdd-btm-30 pdd-top-40 font-20 text-center-vertical col-md-12" [innerHTML]="message">
        </span>
        <div class="pad-sm-none d-flex justify-content-center text-center col-md-12">
          <h3 class="color-gray-dark text-center col-xs-12 pdd-btm-30">Has finalizado ¿Qué quieres hacer?</h3>
          <div class="col-xs-12 col-sm-3">
            <a (click)="back()" routerLinkActive="router-link-active"
              class="u-btn--light u-btn u-btn--line u-btn--small u-btn--icon ">{{ textNext }}</a>
          </div>
          <div class="col-xs-12 col-sm-3">
            <a routerLinkActive="router-link-active"
              [routerLink]="[urlNext]" 
              class="u-btn--light btn-blue u-btn u-btn--line u-btn--small u-btn--icon ">{{ textBack }}</a>
          </div>
        </div>
      </div>
  </div>

</div>
